export default "__VITE_ASSET__40d24789__"